export var CountryEnum = function (CountryEnum) {
  CountryEnum["GB"] = "United Kingdom (the)";
  CountryEnum["DE"] = "Germany";
  return CountryEnum;
}({});
export var CountryCode = function (CountryCode) {
  CountryCode["GB"] = "gb";
  CountryCode["DE"] = "de";
  CountryCode["EN"] = "en";
  return CountryCode;
}({});
export var LegacyCountryCode = function (LegacyCountryCode) {
  LegacyCountryCode["DE"] = "D";
  return LegacyCountryCode;
}({});
export var LanguageLocaleCode = function (LanguageLocaleCode) {
  LanguageLocaleCode["GB"] = "en-GB";
  LanguageLocaleCode["DE"] = "de-DE";
  return LanguageLocaleCode;
}({});